// 公共方法
(function(doc, win) {
    // rem脚本代码
    var docEl = doc.documentElement;
    var clientWidth;
    var recalc = function() {
        clientWidth = docEl.clientWidth;
        if (!clientWidth) return;
        if (clientWidth > 750) docEl.style.fontSize = 10 * (clientWidth / 480) + 'px';
        else docEl.style.fontSize = 10 * (clientWidth / 360) + 'px';
    };
    recalc();
    // common方法
    function contractUs() {
        sensors.track('app_poker_official_site_contact_us');
        document.querySelector('.contract-modal').style.display = "block";
        document.querySelector('.catalog').style.display = "none";
        document.querySelector('.opened-img').style.display = "none";
        document.querySelector('.open-img').style.display = "block";
    }
    function closeCode() {
        document.querySelector('.contract-modal').style.display = "none";
    }
    function openCatalog() {
        document.querySelector('.catalog').style.display = "block";
        document.querySelector('.opened-img').style.display = "block";
        document.querySelector('.open-img').style.display = "none";
    }
    function closeCatalog() {
        document.querySelector('.catalog').style.display = "none";
        document.querySelector('.opened-img').style.display = "none";
        document.querySelector('.open-img').style.display = "block";
    }
    function openWXNotice() {
        document.querySelector('.wx-notice').style.display = "block";
    }
    function closeWXNotice() {
        document.querySelector('.wx-notice').style.display = "none";
    }
    function isWeChatBrowser() {
        return String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) === 'micromessenger';
    }
    function _is_ios() {
        if (navigator.platform) // 解决IOS-13以后版本问题
        return /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
        else {
            var u = navigator.userAgent.toLocaleLowerCase();
            if (u.indexOf('iphone') > -1 || u.indexOf('ipad') > -1) return true;
        }
        return false;
    // return true
    }
    win.contractUs = contractUs;
    win.closeCode = closeCode;
    win.openCatalog = openCatalog;
    win.closeCatalog = closeCatalog;
    win.openWXNotice = openWXNotice;
    win.closeWXNotice = closeWXNotice;
    win.isWeChatBrowser = isWeChatBrowser;
    win._is_ios = _is_ios;
})(document, window);

//# sourceMappingURL=index.aa565e50.js.map
